const KeyCommon = {
  WEB_DIEU_KHOAN: "WEB_DIEU_KHOAN",
  WEB_DIEU_KHOAN_EN: "WEB_DIEU_KHOAN_EN",
  WEB_DIEU_KHOAN_THANH_TOAN: "WEB_DIEU_KHOAN_THANH_TOAN",
  WEB_DIEU_KHOAN_THANH_TOAN_EN: "WEB_DIEU_KHOAN_THANH_TOAN_EN",
};
export default KeyCommon;
